import { actionTypes } from './constants';

export const setShowSwitchOrgModal = (show) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_SWITCH_ORG_MODAL, show });
    };
};
